export default __webpack_public_path__ + "static/media/Mark-6-HUD-08.347d39b0.jpg";